"use client";
import React, { useEffect, useState } from "react"; 
import Link from "next/link";
import { usePathname } from "next/navigation";
import { parseServerFeaturesList, parseName } from "../../lib/function";
import { FaArrowRight } from "react-icons/fa"; // FontAwesome Icon
import { Button } from "react-bootstrap";

type Package = {
  id: string;
  name: string;
  price: string;
  oldPrice: string;
  discount: string;
  term: string;
  features: string[];
  configureUrl: string;
};



type DurationPlan = {
  type: string;
  currency: string;
  period: number;
  price: number;
  actuall_price: number;
  desc: string;
  discount: number;
};

type DurationMap = {
  [key: string]: DurationPlan;
};
const links = [
  { href: "/dedicated-servers-usa", label: "Dedicated Servers" },
  { href: "/dedicated-seo-servers", label: "Dedicated SEO Servers" },
  { href: "/dedicated-reseller", label: "Dedicated Reseller" },
  { href: "/dedicated-special-deals", label: "Dedicated Special Deals" },
];

const ServerPackagesDedRes = () => {
  const [packagesData, setPackagesData] = useState<Package[]>([]);
  const pathname = usePathname();
  const rawSlug = pathname?.split("/").pop() || "";

  useEffect(() => {
    fetch('/api/plan', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        rawSlug
      }),
    })
    .then((res) => res.json())
    .then((response) => {
      const mockPackages = response.data.slice(0, 20).map((item: { id: number, name: string, description:string, duration: DurationMap }): Package => ({
        id: item.id.toString(),
        name: parseName(item.description, "Processor"),
        price: `$${item.duration.monthly.price || 0.00}`,
        oldPrice: `$${item.duration.monthly.actuall_price.toFixed(2)}`,
        discount: item.duration.monthly.discount > 0 ? `Save ${item.duration.monthly.discount}%` : "0",
        term: `Price per ${item.duration.monthly.desc}`,
        features: parseServerFeaturesList(item.description),
        configureUrl: `${process.env.NEXT_PUBLIC_API_BASE_URL}/cart.php?a=add&pid=${item.id}&billingcycle=${item.duration.monthly.type}`
      }));
      setPackagesData(mockPackages);
    });
  }, [rawSlug]);

  return (
    <div className="container mt-4">
      <div className="text-center my-lg-5">
        <h1 className="display-5 fw-bold">
          <span className="text-capitalize">Dedicated SEO Server Solutions</span> 
        </h1>
        <p className="fs-5 fw-normal">Backed by 24/7 On-Premise Support</p> 
      </div>

      <div className="btnGroup my-4 mb-5">
      {links.map(({ href, label }, index) => {
          const isActive = rawSlug === href.replace("/","");
          return (
            <Link 
              key={index} 
              href={href}
              className={`mx-2 my-1 btn btn-lg ${
                isActive 
                ? "darkOne" 
                : "outline-darkZero"
              }`}
            >
              {label}
            </Link>
          );
        })}
      </div>

      {/* Packages List */}
      <div className="row justify-content-center">
        {packagesData.map((pkg) => (
          <div key={pkg.id} className="col-lg-3 col-md-6 col-12 mb-4">
            <div className="h-100 d-flex">
              <div className="card-body">
                {/* <h3 className="card-title fw-bold">
                  <span className="fw-semibold fs-5 textOrange">{pkg.name}</span>
                </h3> */}

                <h3 className="card-title fw-bold fs-5">
                  <span className="textOrange">{pkg.name}</span>
                </h3>

                <p className="text-muted">{pkg.term}</p>
                <div className="d-flex align-items-end mb-2">
                  <span className="display-6 fw-bolder">{pkg.price}</span>
                  <span className="text-muted ms-1">/mo</span>
                </div>
                {pkg.discount !== "0" && (
                  <h4 className="text-muted fw-normal my-2">
                    <del className="text-muted fs-5 fw-bold">{pkg.oldPrice}</del>
                    <span className="textPara alert alert-warning py-1 px-2 fw-semibold ms-2 fntSize">
                      {pkg.discount}
                    </span>
                  </h4>
                )}
                <Link href={pkg.configureUrl}> 
                  <Button className="orangeBtn fw-semibold w-100"  size="lg">
                ORDER <FaArrowRight className="" />
                </Button> 
                </Link>
                <h4 className="fs-5 fw-bold">Features</h4>
                <ul className="list-unstyled custList">
                  {pkg.features.map((feature, index) => (
                    <li key={index}>
                      <span className="text-success">✔</span> <span className="textHad fw-semibold">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServerPackagesDedRes;